export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrats"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher un contrat, un client, un produit..."])},
        "period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Période"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun contrat trouvé"])},
        "fetch_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de récupérer les contrats"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contracts"])},
        "search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search a contract, a customer, a product..."])},
        "period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Period"])},
        "no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No contract found"])},
        "fetch_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unable to fetch the contracts"])}
      }
    }
  })
}
